'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$Roles$OrRole(r1, r2) {
  this.Eb = null;
  this.Ec = null;
  this.Eb = r1;
  this.Ec = r2;
}
export { $c_Lpresto_types$Roles$OrRole as $c_Lpresto_types$Roles$OrRole };
$p = $c_Lpresto_types$Roles$OrRole.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$Roles$OrRole;
/** @constructor */
function $h_Lpresto_types$Roles$OrRole() {
}
export { $h_Lpresto_types$Roles$OrRole as $h_Lpresto_types$Roles$OrRole };
$h_Lpresto_types$Roles$OrRole.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().S(this, (-889275714), false);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpresto_types$Roles$OrRole)) {
    var x = this.Eb;
    var x$2 = x$0.Eb;
    if (((x === null) ? (x$2 === null) : x.i(x$2))) {
      var x$3 = this.Ec;
      var x$4 = x$0.Ec;
      return ((x$3 === null) ? (x$4 === null) : x$3.i(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.r = (function() {
  return 2;
});
$p.s = (function() {
  return "OrRole";
});
$p.j = (function(n) {
  if ((n === 0)) {
    return this.Eb;
  }
  if ((n === 1)) {
    return this.Ec;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.l = (function() {
  return (((("(" + this.Eb) + " || ") + this.Ec) + ")");
});
$p.T7 = (function(tk) {
  return (this.Eb.T7(tk) || this.Ec.T7(tk));
});
function $isArrayOf_Lpresto_types$Roles$OrRole(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.k6)));
}
export { $isArrayOf_Lpresto_types$Roles$OrRole as $isArrayOf_Lpresto_types$Roles$OrRole };
var $d_Lpresto_types$Roles$OrRole = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$Roles$OrRole, "presto.types$Roles$OrRole", ({
  k6: 1,
  k7: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_types$Roles$OrRole as $d_Lpresto_types$Roles$OrRole };
//# sourceMappingURL=presto.types$-Roles$-Or-Role.js.map
